module.exports = __webpack_public_path__ + "static/media/Axon I-Classic.2cb3b5dd.png";